// global polyfill to fix some packages like https://github.com/donavon/use-dark-mode
window.global = window
